const OBJECTIVE_STATUS_OPTIONS = [
  { color: '#607d8b', icon: 'square', labelKey: 'todo', value: 'Todo' },
  { color: '#f5a623', icon: 'caret-right', labelKey: 'doing', value: 'Doing' },
  { color: '#4caf50', icon: 'check', labelKey: 'completed', value: 'Completed' },
  { color: '#c62828', icon: 'times', labelKey: 'failed', value: 'Failed' },
  { color: '#9e9e9e', icon: 'times', labelKey: 'cancelled', value: 'Cancelled' },
  { color: '#5c6bc0', icon: 'archive', labelKey: 'archive', value: 'Archived' },
] as const;

export default OBJECTIVE_STATUS_OPTIONS;
